import * as React from 'react';

const Heatmap = (props:any) => (
    <svg width={64} height={64} viewBox="0 0 64 64" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                d="M24.394 20.72l-.34.672-.697.28C9.903 27.089 4.537 38.428 11.827 45.92c7.273 7.475 20.52 5.374 32.514-4.323 12.7-10.268 16.012-21.013 6.622-27.47-10.758-7.395-20.86-4.678-26.569 6.595z"
                stroke="#D2D5D8"
                strokeWidth="4"
                fill="#D2D5D8"
            />
            <path
                d="M26.434 21.28c3.747-7.398 10.735-9.642 18.18-4.524 7.444 5.118 3.15 13.125-4.007 18.911-7.156 5.786-16.308 8.112-21.704 2.566-5.397-5.546-1.166-13.452 7.531-16.952z"
                fillOpacity=".24"
                fill="#444F5C"
            />
            <path
                d="M25.47 23.634c1.873-3.7 5.367-4.821 9.09-2.262 3.721 2.559 1.575 6.562-2.004 9.455-3.578 2.893-8.154 4.056-10.852 1.283-2.698-2.773-.583-6.726 3.766-8.476z"
                fill="#7B838C"
            />
        </g>
    </svg>
);

export default Heatmap;

